import { render } from "./Techniques.vue?vue&type=template&id=1abf25ec&scoped=true"
import script from "./Techniques.vue?vue&type=script&lang=js"
export * from "./Techniques.vue?vue&type=script&lang=js"

import "./Techniques.vue?vue&type=style&index=0&id=1abf25ec&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abf25ec"]])

export default __exports__